import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { ApplicationState } from './types';

export const getters: GetterTree<ApplicationState, RootState> = {};
